import React, { useState } from "react";

import Select from "react-select";
import { deleteTeamHistory } from "services/teamhistory_service";

function App({ history = [], setHistory, isReadOnly = false, type = "Jogador" }) {
  const [refresh, setRefresh] = useState(true);

  const options = [
    {
      value: "E2023/24",
      label: "2023/24",
    },
    {
      value: "E2022/23",
      label: "2022/23",
    },
    {
      value: "E2021/22",
      label: "2021/22",
    },
    {
      value: "E2020/21",
      label: "2020/21",
    },
    {
      value: "E2019/20",
      label: "2019/20",
    },
    {
      value: "E2018/19",
      label: "2018/19",
    },
    {
      value: "E2017/18",
      label: "2017/18",
    },
    {
      value: "E2016/17",
      label: "2016/17",
    },
    {
      value: "E2015/16",
      label: "2015/16",
    },
    {
      value: "E2014/15",
      label: "2014/15",
    },
    {
      value: "E2013/14",
      label: "2013/14",
    },
    {
      value: "E2012/13",
      label: "2012/13",
    },
    {
      value: "E2011/12",
      label: "2011/12",
    },
    {
      value: "E2010/11",
      label: "2010/11",
    },
    {
      value: "E2009/10",
      label: "2009/10",
    },
    {
      value: "E2008/09",
      label: "2008/09",
    },
    {
      value: "E2007/08",
      label: "2007/08",
    },
    {
      value: "E2006/07",
      label: "2006/07",
    },
    {
      value: "E2005/06",
      label: "2005/06",
    },
    {
      value: "E2004/05",
      label: "2004/05",
    },
    {
      value: "E2003/04",
      label: "2003/04",
    },
    {
      value: "E2002/03",
      label: "2002/03",
    },
    {
      value: "E2001/02",
      label: "2001/02",
    },
    {
      value: "E2000/01",
      label: "2000/01",
    },
  ];

  const addHistoryLine = () => {
    history.push({});

    setRefresh(!refresh); // necessary to refresh the component
    setHistory(history);
  };

  const removeTeamHistory = async (index) => {
    console.log("🚀 ~ file: TeamHistory.js:116 ~ removeTeamHistory ~ index:", index)
    if (history && history[index] && history[index].id) {
      await deleteTeamHistory(history[index].id);
    }
    let newHistory = []
    
    if(history.length > 1){
      newHistory = history.splice(index, 1);
    }
    
    setHistory(newHistory);

    setRefresh(!refresh); // necessary to refresh the component
  };

  return (
    <div className="geral">
      <table className="table fullwidth">
        <thead>
          <tr>
            <th>Época</th>
            <th>Equipa</th>
            {type === "Jogador" && (
              <>
                <th>Jogos</th>
                <th>Golos</th>
                <th>Assistencias</th>
                <th></th>
              </>
            )}
            {type === "Treinador" && (
              <>
                <th>Função</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {history.map((el, index) => (
            <tr key={index}>
              <th>
                <Select
                  isDisabled={isReadOnly}
                  defaultValue={() => {
                    if (el?.attributes?.season) {
                      let option = options.find((opt) => {
                        return opt.value === el?.attributes?.season;
                      });

                      return option;
                    }
                  }}
                  onChange={(evt) => {
                    history[index].season = evt.value;
                    setHistory(history);
                  }}
                  options={options}
                />
              </th>
              <td>
                <input
                  disabled={isReadOnly}
                  className="input"
                  value={el?.attributes?.team}
                  onChange={(evt) => {
                    history[index].team = evt.target.value;
                    setHistory(history);
                  }}
                ></input>
              </td>
              {type === "Jogador" && (
                <>
                  <td>
                    <input
                      className="input"
                      disabled={isReadOnly}
                      style={{ width: "45px" }}
                      value={el?.attributes?.games}
                      onChange={(evt) => {
                        history[index].games = evt.target.value;
                        setHistory(history);
                      }}
                    ></input>
                  </td>
                  <td>
                    <input
                      className="input"
                      disabled={isReadOnly}
                      style={{ width: "45px" }}
                      value={el?.attributes?.goals}
                      onChange={(evt) => {
                        history[index].goals = evt.target.value;
                        setHistory(history);
                      }}
                    ></input>
                  </td>
                  <td>
                    {" "}
                    <input
                      className="input"
                      style={{ width: "45px" }}
                      disabled={isReadOnly}
                      value={el?.attributes?.assistances}
                      onChange={(evt) => {
                        history[index].assistances = evt.target.value;
                        setHistory(history);
                      }}
                    ></input>
                  </td>
                </>
              )}
              {type === "Treinador" && (
                <td>
                  <input
                    disabled={isReadOnly}
                    className="input"
                    value={el?.attributes?.function}
                    onChange={(evt) => {
                      history[index].function = evt.target.value;
                      setHistory(history);
                    }}
                  ></input>
                </td>
              )}
              <td>
                {!isReadOnly && <i
                  onClick={() => removeTeamHistory(index)}
                  style={{ marginTop: "7px" }}
                  className="fas fa-trash"
                ></i>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {!isReadOnly && (
        <div
          style={{
            padding: "1%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <i
            onClick={() => addHistoryLine()}
            className="fa fa-plus circled-icon"
          ></i>
        </div>
      )}
    </div>
  );
}

export default App;
